var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main',{staticClass:"profile-page py-16"},[_c('profile-tab'),_c('branches')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }